// extracted by mini-css-extract-plugin
module.exports = {"managers":"styles_managers__3VXZJ","managerCard":"styles_managerCard__2acR1","image":"styles_image__1qk3t","info":"styles_info__30czI"};